import { supabase } from './authService';

export interface Banner {
  id: string;
  title_ko: string | null;
  title_en: string | null;
  desc_ko: string | null;
  desc_en: string | null;
  image_url: string | null;
  link_url: string | null;
  position: string;
  is_published: boolean;
  sort_order: number;
  start_at: string | null;
  end_at: string | null;
  banner_type: string;
  meta: Record<string, any> | null;
  created_at: string;
  updated_at: string;
}

export type BannerInput = Omit<Banner, 'id' | 'created_at' | 'updated_at'>;

export const fetchAllBanners = async (): Promise<Banner[]> => {
  const { data, error } = await supabase
    .from('banners')
    .select('*')
    .order('sort_order', { ascending: true })
    .order('created_at', { ascending: false });
  if (error) throw error;
  return data ?? [];
};

export const fetchActiveBanner = async (position: string, bannerType?: string): Promise<Banner | null> => {
  const now = new Date().toISOString();
  let query = supabase
    .from('banners')
    .select('*')
    .eq('position', position)
    .eq('is_published', true)
    .or(`start_at.is.null,start_at.lte.${now}`)
    .or(`end_at.is.null,end_at.gte.${now}`)
    .order('sort_order', { ascending: true })
    .limit(1);

  if (bannerType) query = (query as any).eq('banner_type', bannerType);

  const { data, error } = await query;
  if (error) return null;
  return (data as Banner[])?.[0] ?? null;
};

export const createBanner = async (input: BannerInput): Promise<Banner> => {
  const { data, error } = await supabase
    .from('banners')
    .insert(input)
    .select()
    .single();
  if (error) throw error;
  return data;
};

export const updateBanner = async (id: string, patch: Partial<BannerInput>): Promise<Banner> => {
  const { data, error } = await supabase
    .from('banners')
    .update({ ...patch, updated_at: new Date().toISOString() })
    .eq('id', id)
    .select()
    .single();
  if (error) throw error;
  return data;
};

export const deleteBanner = async (id: string): Promise<void> => {
  const { error } = await supabase.from('banners').delete().eq('id', id);
  if (error) throw error;
};
